<div style="display: block; position:relative">
    <!-- <p-dropdown 
        [options]="timezones" 
        [(ngModel)]="selectedTimezone"
        (onChange)="handleTimezoneChange($event)"
        (click)="handleClick($event)"
        optionLabel="label" 
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search timezone..."
        [style]="{'font-size': '11px', 'width':'100%', 'border': 'none', 'outline': 'none', 'box-shadow': 'none', 'text-align':'justify'}"
        [showClear]="false"
        appendTo="body"
        (onShow)="onDropdownShow($event)"
        styleClass="no-border-dropdown timezone-dropdown"
        panelStyleClass="custom-dropdown-header">
    </p-dropdown> -->

    Hello timezone
</div>